import { render, staticRenderFns } from "./ProductKitMaintain.vue?vue&type=template&id=16897e24&"
import script from "./ProductKitMaintain.vue?vue&type=script&lang=js&"
export * from "./ProductKitMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16897e24')) {
      api.createRecord('16897e24', component.options)
    } else {
      api.reload('16897e24', component.options)
    }
    module.hot.accept("./ProductKitMaintain.vue?vue&type=template&id=16897e24&", function () {
      api.rerender('16897e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-kit/ProductKitMaintain.vue"
export default component.exports